import { createI18n } from 'vue-i18n'
import fr from './locale/fr'
import ar from './locale/ar'

export const i18n = createI18n({
  legacy: false,
  locale: 'fr', // default language
  fallbackLocale: 'fr',
  messages: {
    fr,
    ar
  }
})